import { useState, useRef, useContext } from "react";
import { Row, Col,Button , Form, InputGroup, Card , ListGroup} from "react-bootstrap";
import LableValueDisplay from "../Client/LableValueDisplay";
import ListGroupTextItem from "./Elements/ListGroupTextItem";
import Icon from "../Icon/Icon";
import { useApiClient } from "../../ApiService/useApiClient";
import { AppContext } from "../../context/AppContext";

const EmploymentDetails = ({datainfo}) => {


  const {SiteConfig} = useContext(AppContext);
  const api = useApiClient();
  //const data = datainfo.agent;  
  const [data, setData] = useState(datainfo.agent);  
  const[restrictedMode, setRestrictedMode] = useState((SiteConfig.CURRENT_USER_ROLE=="user"?true:false));

  const fullname = data.title +' '+ data.agentFname +' '+ data.agentLname;

  const [editMode, setEditMode] = useState(false);
  const [error,setError] = useState(null);
  const modalForm = useRef(null);


  function HandleEditClick(){
    setEditMode(true)
  }
  function HandlePreviewClick(){
    setEditMode(false)
  }

  function handleFormSubmit(event){

    event.preventDefault();
  let EmpStartDate = modalForm.current.querySelector('#EmpStartDate').value; 
  let JobRole = modalForm.current.querySelector('#JobRole').value; 
 //let JobDescription = modalForm.current.querySelector('#JobDescription').value; 
  let JobRoleStartDate = modalForm.current.querySelector('#JobRoleStartDate').value; 
  let PayrollReference = modalForm.current.querySelector('#PayrollReference').value; 
  let NINumber = modalForm.current.querySelector('#NINumber').value; 
  let Nationality = modalForm.current.querySelector('#Nationality').value; 
  let MaritalStatus = modalForm.current.querySelector('#MaritalStatus').value; 
  let Dependants = modalForm.current.querySelector('#Dependants').value; 
  let PlaceofBirth = modalForm.current.querySelector('#PlaceofBirth').value; 
  let PassportNo = modalForm.current.querySelector('#PassportNo').value; 
  let VisaType = modalForm.current.querySelector('#VisaType').value; 
  let VisaExpiryDate = modalForm.current.querySelector('#VisaExpiryDate').value; 
  let DrivinglicenceNo = modalForm.current.querySelector('#DrivinglicenceNo').value; 
  let Bank = modalForm.current.querySelector('#Bank').value; 
  let SortCode = modalForm.current.querySelector('#SortCode').value; 
  let AccountNumber = modalForm.current.querySelector('#AccountNumber').value; 

 //let Password = modalForm.current.querySelector('#Password').value; 

  const frmFormData = new FormData();
        frmFormData.append("AgentId", data.agentId) 
        frmFormData.append("EmpStartDate", EmpStartDate) 
        frmFormData.append("JobRoleId", JobRole) 
        //frmFormData.append("JobDescription", JobDescription)  
        frmFormData.append("JobRoleStartDate", JobRoleStartDate)  
        frmFormData.append("PayrollReference", PayrollReference)  
        frmFormData.append("NiNumber", NINumber)  
        frmFormData.append("Nationality", Nationality)  
        frmFormData.append("MaritalStatus", MaritalStatus)  
        frmFormData.append("Dependants", Dependants)  
        frmFormData.append("BirthPlace", PlaceofBirth)  
        frmFormData.append("PassportNo", PassportNo)  
        frmFormData.append("VisaDetails", VisaType)  
        frmFormData.append("VisaExpiryDate", VisaExpiryDate)  
        frmFormData.append("DrivingLicenceNo", DrivinglicenceNo)  
        frmFormData.append("BankName", Bank)  
        frmFormData.append("BankAccountSortcode", SortCode)  
        frmFormData.append("BankAccountNo", AccountNumber)  
                              
        //console.log(frmFormData);

        const sURL = "HMCareStaff/staff/modify/";

      
        api.post(sURL,frmFormData)
        .then((Response)=>{

            let updatedDataObj = Response.data;  

            //console.log({updatedDataObj})

            setData(updatedDataObj)          
            //updateState(updatedDataObj)
            
        }).catch(error => {
            setError(error);     
            //console.log({error})
        });


  setEditMode(false)

  }

  return (
     
    <><Form ref={modalForm} onSubmit={handleFormSubmit}>
<Row>
{!editMode && !restrictedMode && <div className="col-md-12" style={{textAlign:"left",marginBottom:"5px",}}><span onClick={HandleEditClick} style={{cursor:"pointer", color:"green", textAlign:"right",}}><Icon name="edit"></Icon> Edit</span></div>}
{/* {editMode && !restrictedMode && <div className="col-md-12" style={{textAlign:"left",}}><span onClick={HandlePreviewClick} style={{cursor:"pointer", color:"green", textAlign:"right",}}><Icon name="save-fill"></Icon> Exit Edit Mode</span></div> } */}
 
{editMode && 
  <>
      <div className="col-md" style={{padding:"15px",}}>     
        <Button variant="primary" size="md" type="submit">Save Changes</Button>         
        <Button variant="danger" size="md" onClick={HandlePreviewClick} style={{marginLeft:"10px",}}><Icon name="cancel-fill"></Icon> Cancel</Button>     
      </div>          
      </>    
      }   
</Row>
 {/* <br></br> */}
<Row>
  <div className="col-md-6">

  <Card>

  {/* {editMode &&
      <>
      <div className="col-md-6">
      <ListGroup variant="flush">
        <ListGroup.Item><Button variant="primary" type="submit" >Save Changes</Button></ListGroup.Item>
      </ListGroup></div></> }    */}

      <ListGroup variant="flush">
          <ListGroup.Item><LableValueDisplay name={"ID"} value={data.agentId} /></ListGroup.Item>
          <ListGroupTextItem editMode={editMode} id={"EmpStartDate"} name={"Emp Start Date"} value={data.empStartDate} imputtype="date" />
          <ListGroupTextItem editMode={editMode} id={"JobRole"} name={"Job Role"} value={datainfo.jobRole?.jobRoleName}  />
          <ListGroupTextItem editMode={false} id={"JobDescription"} name={"Job Description"} value={datainfo.jobRole?.jobRoleDesc}  />
          <ListGroupTextItem editMode={editMode} id={"JobRoleStartDate"} name={"Job Role Start Date"} value={data.jobRoleStartDate} imputtype="date"  />
          <ListGroupTextItem editMode={editMode} id={"PayrollReference"} name={"Payroll Reference"} value={data.payrollReference}  />
          <ListGroupTextItem editMode={editMode} id={"NINumber"} name={"NI Number"} value={data.niNumber}  />
          <ListGroupTextItem editMode={editMode} id={"Nationality"} name={"Nationality"} value={data.nationality}  />
          <ListGroupTextItem editMode={editMode} id={"MaritalStatus"} name={"Marital Status"} value={data.maritalStatus}  />
          <ListGroupTextItem editMode={editMode} id={"Dependants"} name={"Dependants"} value={data.dependants}  />
          <ListGroupTextItem editMode={editMode} id={"PlaceofBirth"} name={"Place of Birth"} value={data.birthPlace}  />
          

          {/* <ListGroup.Item><LableValueDisplay name={"ID"} value={data.agentId} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"Emp Start Date"} value={data.empStartDate} /></ListGroup.Item>          
          <ListGroup.Item><LableValueDisplay name={"Job Role"} value={datainfo.jobRole?.jobRoleName} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"Job Description"} value={datainfo.jobRole?.jobRoleDesc} /></ListGroup.Item>          
          <ListGroup.Item><LableValueDisplay name={"Job Role Start Date"} value={data.jobRoleStartDate} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"payroll Reference"} value={data.payrollReference} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"NI Number"} value={data.niNumber} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"Nationality"} value={data.nationality} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"Marital Status"} value={data.maritalStatus} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"Dependants"} value={data.dependants} /></ListGroup.Item>        
          <ListGroup.Item><LableValueDisplay name={"Place of Birth"} value={data.birthPlace} /></ListGroup.Item> */}

      </ListGroup>
  </Card>
  </div>
  <div className="col-md-6">
  <Card>
      {/* <Card.Header>Service Details</Card.Header> */}
      <ListGroup variant="flush">
      {/* <ListGroup.Item><p><br></br><em><u>Visa Details</u></em></p></ListGroup.Item> */}


          <ListGroupTextItem editMode={editMode} id={"PassportNo"} name={"Passport No"} value={data.passportNo}  />
          <ListGroupTextItem editMode={editMode} id={"VisaType"} name={"Visa Type"} value={data.visaDetails}  />
          <ListGroupTextItem editMode={editMode} id={"VisaExpiryDate"} name={"Visa Expiry Date"} value={data.visaExpiryDate} imputtype="date" />
          <ListGroupTextItem editMode={editMode} id={"DrivinglicenceNo"} name={"Driving licence No"} value={data.drivingLicenceNo}  />
          <ListGroup.Item><p><br></br><em><u>Bank Account Details</u></em></p></ListGroup.Item>
          <ListGroupTextItem editMode={editMode} id={"Bank"} name={"Bank"} value={data.bankName}  />
          <ListGroupTextItem editMode={editMode} id={"SortCode"} name={"Sort Code"} value={data.bankAccountSortcode}  />
          <ListGroupTextItem editMode={editMode} id={"AccountNumber"} name={"Account Number"} value={data.bankAccountNo}  />

          {/* <ListGroup.Item><LableValueDisplay name={"Passport No"} value={data.passportNo} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"Visa Type"} value={data.visaDetails} /></ListGroup.Item>          
          <ListGroup.Item><LableValueDisplay name={"Visa Expiry Date"} value={data.visaExpiryDate} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"Driving licence No"} value={data.drivingLicenceNo} /></ListGroup.Item>          
          <ListGroup.Item><p><br></br><em><u>Bank Account Details</u></em></p></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"Bank"} value={data.bankName} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"Sort Code"} value={data.bankAccountSortcode} /></ListGroup.Item>
          <ListGroup.Item><LableValueDisplay name={"Account Number"} value={data.bankAccountNo} /></ListGroup.Item> */}
         
      </ListGroup>    
     
  </Card>
  </div>
    
  </Row></Form>
<br></br>
    
    </>
  )
}

export default EmploymentDetails